import React from "react";

import { CustomHeading } from "./style";

const DashboardHeader = () => (
  <CustomHeading element="h1" size="md" noMargin>
    Indicadores
  </CustomHeading>
);

export default DashboardHeader;
